import { BaseGetRequest } from './core/baseGetRequest';
import { FileUrl, FileUrlDynamicType } from '../models/fileUrl';
import { Authentication } from './core/baseRequest';

export class ItineraryPdfUrlRequest extends BaseGetRequest<FileUrl> {
    constructor(public id: string) {
        super(`itineraries/${id}/pdf`, {}, FileUrlDynamicType, Authentication.SharingToken);
    }
}
